import Skeleton from '@mui/material/Skeleton';

const CustomLoader = (props) =>{
   const { noLines, variant, animation, fontSize  } = props;
    return(
        <div>
            {
                noLines.map((e, index) =>(
                    <Skeleton key={ index } variant={ variant } animation={ animation }  sx={{ fontSize: { fontSize } }}></Skeleton>
                ))
            }

        </div>
    )
}

export default CustomLoader;